import React from "react";
import { useNavigate } from "react-router-dom";

const products = [
  {
    name: "Drone-X Pro",
    price: "$355.00",
    image: "https://via.placeholder.com/400x250?text=Drone-X+Pro",
    hero: "https://via.placeholder.com/800x350?text=Drone+Hero",
    features: [
      {
        section: "Camera",
        items: ["4K Camera", "Stable Video Output"]
      },
      {
        section: "Performance",
        items: ["30 Min Battery Life", "Speed: 50 km/h", "Control Range: 2 km"]
      },
      {
        section: "Technology",
        items: ["Auto Follow Sensor", "Subject Tracking Technology", "Easy To Operate"]
      }
    ],
    description:
      "Drone-X Pro is designed for both professionals and hobbyists. Capture stunning aerial views with 4K camera and advanced flight stability.",
  },
  {
    name: "Sky Phantom",
    price: "$299.00",
    image: "https://via.placeholder.com/400x250?text=Sky+Phantom",
    hero: "https://via.placeholder.com/800x350?text=Sky+Phantom+Hero",
    features: [
      {
        section: "Camera",
        items: ["HD Camera"]
      },
      {
        section: "Performance",
        items: ["25 Min Battery Life", "Speed: 40 km/h", "Control Range: 1.5 km"]
      },
      {
        section: "Convenience",
        items: ["One Key Return", "360° Flip", "Altitude Hold", "LED Navigation Lights"]
      }
    ],
    description:
      "Sky Phantom is the perfect drone for beginners. Enjoy smooth flights, easy controls, and creative aerial photography.",
  },
];



function ProductPage() {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-50 min-h-screen pt-0 px-4">

      <h2 className="text-3xl font-bold text-center mb-8">Our Products</h2>
      <div className="flex flex-col gap-12 max-w-4xl mx-auto">
        {products.map((product, idx) => (
          <section
            key={idx}
            className="bg-white rounded-xl shadow-lg p-8 transition w-full"
          >
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <img
                src={product.image}
                alt={product.name}
                className="w-full md:w-64 h-48 object-cover rounded-lg bg-gray-100"
              />
              <div className="flex-1">
                <h3 className="font-bold text-2xl mb-2">{product.name}</h3>
                <div className="text-blue-600 font-bold text-lg mb-2">{product.price}</div>
                <p className="text-gray-700 mb-4">{product.description}</p>
                <div className="mb-4">
                  {product.features.map((section, sidx) => (
                    <div key={sidx} className="mb-3">
                      <h4 className="font-semibold text-md mb-1 text-blue-700">{section.section}</h4>
                      <ul className="list-disc list-inside ml-4">
                        {section.items.map((item, iidx) => (
                          <li key={iidx} className="text-gray-800">{item}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
                <button
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 font-semibold"
                  onClick={() => navigate("/product-details", { state: product })}
                >
                  View Details
                </button>
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default ProductPage;
